module.exports = __webpack_public_path__ + "img/image-01.069c6d8b.jpeg";